module.exports = __webpack_public_path__ + "95e2809573a14f70b8db8114c414b00a.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/755.png
// module id = 1691
// module chunks = 2